export {
    default as TemplateQuestions,
    ITemplateQuestionsProps,
} from './questions';
